export default __webpack_public_path__ + "static/media/icon-arrow-up-green.9a6fb960.svg";